<template>
	<span>{{name}}</span>
</template>

<style lang="scss">
	
</style>

<script>
export default {
	props: {
		name: {
			type: String,
			default: 'xxx',
		},
	},
}
</script>